import React from 'react';
import { Button, Col, Drawer, Row, Table, Tag } from 'antd';
import { useState, useEffect } from 'react';
import PageTitle from 'shared_components/page_title';
import DownloadCSV from 'shared_components/download_csv';
import { fetchAnalyzerItems, applySorting } from 'services/settings/lookup_table/analyzer.jsx';
import AnalyzerForm from './analyzerForm.jsx';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import DragableBodyRow from 'shared_components/drag_and_drop_row';
import { showMessage } from 'services/settings/message';

function Analyzer() {
	const [analyzer, setAnalyzer] = useState([]);
	const [hasReordered, setHasReordered] = useState(false);
	const [drawerState, setDrawerState] = useState({
		visible: false,
		drawerTitle: '',
		selecetedData: null,
		buttonNames: '',
	});

	useEffect(() => {
		getAnalyzers();
	}, []);

	const getAnalyzers = async () => {
		const data = await fetchAnalyzerItems();
		console.log('Analyzer data from API:', data);
		// Sort by analyzerSort ASC, but put records without analyzerSort at the end
		const sortedData = (data || []).sort((a, b) => {
			if (a.analyzerSort != null && b.analyzerSort != null) {
				return a.analyzerSort - b.analyzerSort;
			}
			if (a.analyzerSort == null) return 1;
			if (b.analyzerSort == null) return -1;
			return 0;
		});
		console.log('Sorted analyzer data:', sortedData);
		setAnalyzer(sortedData);
	};

	const onSuccessCreate = async () => {
		onDrawerClose();
		await getAnalyzers();
		showMessage('M0002');
	};

	const onSuccessUpdate = async () => {
		onDrawerClose();
		await getAnalyzers();
		showMessage('M0003');
	};

	const applySort = async () => {
		const dataPayload = analyzer.map((rec, index) => {
			return {
				analyzerID: rec.analyzerID,
				analyzerSort: index + 1,
			};
		});

		await applySorting(dataPayload);
		setHasReordered(false);
	};

	const moveRow = (dragIndex, hoverIndex) => {
		const dragRow = analyzer[dragIndex];

		const updatedData = update({ analyzer }, {
			analyzer: { $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]] }
		});

		setAnalyzer(updatedData.analyzer);
		setHasReordered(true);
	};

	const showDrawer = record => {
		setDrawerState({
			visible: true,
			drawerTitle: 'ADD ANALYZER',
			selecetedData: null,
			buttonNames: 'ADD',
		});
	};

	const displayDrawer = record => {
		setDrawerState({
			visible: true,
			drawerTitle: 'UPDATE ANALYZER',
			selecetedData: record,
			buttonNames: 'UPDATE',
		});
	};

	const onDrawerClose = () => {
		setDrawerState({
			visible: false,
			drawerTitle: '',
			selecetedData: null,
			buttonNames: '',
		});
	};

	const components = {
		body: {
			row: DragableBodyRow,
		},
	};

	const columns = [
		{
			title: 'ANALYZER NAME',
			dataIndex: 'analyzerName',
			width: 400,
			sorter: (a, b) => { return a.analyzerName.localeCompare(b.analyzerName) },
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: 'DATE CREATED',
			dataIndex: 'createdDate',
			width: 200,
			render: date => date ? new Date(date).toLocaleDateString() : '',
		},
		{
			title: 'STATUS',
			dataIndex: 'active',
			width: 100,
			render: active => (
				<Tag color={active === 0 ? 'red' : 'green'}>{active === 0 ? 'INACTIVE' : 'ACTIVE'}</Tag>
			),
		},
	];

	return (
		<>
			<Row justify="end" style={{ marginTop: 12, marginBottom: 12, display: 'flex', gap: '10px' }}>
				<DownloadCSV
					confirmRequired={true}
					isLookupTable={true}
					confirmDetails={{
						section: 'ANALYZERS',
						count: analyzer.length
					}}
					data={analyzer}
					filename="analyzers"
					columns={[
						{ title: 'ANALYZER NAME', dataIndex: 'analyzerName' },
						{ 
							title: 'DATE CREATED', 
							dataIndex: 'createdDate',
							render: date => date ? new Date(date).toLocaleDateString() : ''
						},
						{ 
							title: 'STATUS', 
							dataIndex: 'active',
							render: active => active === 0 ? 'INACTIVE' : 'ACTIVE'
						}
					]}
				/>
				<Button
					onClick={applySort}
					shape="round"
					type="primary"
					disabled={!hasReordered}
				>
					APPLY SORTING
				</Button>
				<Button
					// disabled={buttonDisable}
					type="primary"
					shape="round"
					onClick={showDrawer}
					style={{ marginRight: '15px' }}
					// icon={<PlusOutlined />}
				>
					ADD ANALYZER
				</Button>
				{/* <AnalyzerPager handleChange={this.handleChange} /> */}
			</Row>
			<DndProvider backend={HTML5Backend}>
				<Table
					dataSource={analyzer}
					columns={columns}
					components={components}
					pagination={false}
					rowKey={record => record.analyzerID}
					onRow={(record, index) => ({
						index: analyzer.findIndex(item => item.analyzerID === record.analyzerID),
						moveRow: moveRow,
						onDoubleClick: () => {
							displayDrawer(record);
						},
					})}
				/>
			</DndProvider>
			<Drawer
				title={drawerState.drawerTitle}
				width="30%"
				visible={drawerState.visible}
				onClose={onDrawerClose}
				destroyOnClose
			>
				<AnalyzerForm
					buttonNames={drawerState.buttonNames}
					onDrawerClose={onDrawerClose}
					selecetedData={drawerState.selecetedData}
					onSuccessCreate={onSuccessCreate}
					onSuccessUpdate={onSuccessUpdate}
				/>
			</Drawer>
		</>
	);
}

export default Analyzer;
